import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';

import get from 'lodash/get';


import LoadingScreen from '../common/loadingScreen';
import { userPasswordActions } from '../store/reducers/profile';
import ThemeProviderLayout from '../common/ThemeProviderLayout';

const ProtectedRoute = () => {
  const auth = useAuth();
  const authUserId = get(auth, 'user.profile.sub', '');

  const dispatch = useDispatch();

  useEffect(() => {
    if (auth && !auth.isLoading) {
      if (!auth.isAuthenticated) {
        auth.signinRedirect();
      }
    }
  }, [auth]);

  useEffect(() => {
    if (authUserId) {
      dispatch(userPasswordActions.getUserProfileDataRequest(authUserId));
    }
  }, [authUserId]);

  if (!auth.isAuthenticated) {
    return <LoadingScreen />;
  }

  return <ThemeProviderLayout />;
};

export default ProtectedRoute;
